module.exports = __webpack_public_path__ + "img/009.d2e1aa48.jpg";